import { ChevronDown, Copy } from 'lucide-react';
import React, { useState } from 'react';
import BlockAdvancedSection from './BlockAdvancedSection';
import FlatPreviewTable from './FlatPreviewTable';
import VillaPreviewTable from './VillaPreviewTable';
import { blockTotalUnits, isVillaStreet, pruneBlockFlatLayout } from './communitySiteUtils';

const BlockConfigCard = ({
  block,
  blockIndex,
  onChange,
  onClone,
  showClone = true,
}) => {
  const [expanded, setExpanded] = useState(blockIndex === 0);
  const villa = isVillaStreet(block);
  const units = blockTotalUnits(block);

  const update = (field, value) => {
    const next = { ...block, [field]: value };
    onChange(
      !villa && (field === 'floors' || field === 'flatsPerFloor')
        ? pruneBlockFlatLayout(next)
        : next
    );
  };

  return (
    <div className="community-block-card">
      <button
        type="button"
        className="community-block-card-header"
        onClick={() => setExpanded(!expanded)}
      >
        <div>
          <span className="community-block-card-title">{block.name}</span>
          <span className="community-block-card-subtitle">
            {villa
              ? `${block.flatsPerFloor} villas`
              : `${block.floors} floors · ${block.flatsPerFloor}/floor · ${units} units`}
          </span>
        </div>
        <ChevronDown className={`w-4 h-4 transition-transform ${expanded ? 'rotate-180' : ''}`} />
      </button>

      {expanded && (
        <div className="community-block-card-body">
          <div
            className={`community-block-card-fields-row${villa ? ' community-block-card-fields-row--villa' : ''}`}
          >
            <label className="community-field community-field--compact">
              <span>Name</span>
              <input
                type="text"
                value={block.name}
                onChange={e => update('name', e.target.value)}
              />
            </label>

            {!villa && (
              <label className="community-field community-field--compact">
                <span>Floors</span>
                <input
                  type="number"
                  min={1}
                  max={100}
                  value={block.floors}
                  onChange={e =>
                    update('floors', Math.max(1, parseInt(e.target.value, 10) || 1))
                  }
                />
              </label>
            )}

            <label className="community-field community-field--compact">
              <span>{villa ? 'Villas' : 'Flats per floor'}</span>
              <input
                type="number"
                min={1}
                max={500}
                value={block.flatsPerFloor}
                onChange={e =>
                  update('flatsPerFloor', Math.max(1, parseInt(e.target.value, 10) || 1))
                }
              />
            </label>
          </div>

          <div className="community-block-card-panels-row">
            <div className="community-block-card-panel community-block-card-panel--preview">
              {villa ? (
                <VillaPreviewTable street={block} onStreetChanged={onChange} />
              ) : (
                <FlatPreviewTable block={block} onBlockChanged={onChange} />
              )}
            </div>

            <div className="community-block-card-panel community-block-card-panel--advanced">
              <BlockAdvancedSection block={block} onChange={onChange} />
            </div>
          </div>

          {showClone && (
            <button type="button" className="community-clone-btn" onClick={onClone}>
              <Copy className="w-4 h-4" />
              Clone
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default BlockConfigCard;
